import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import Storage from "../../../helpers/Storage";
import CheckBox from "../CheckBox/CheckBox";
import Label from "../Label/Label";
import { default as _ } from "../../../helpers/Translate";
import T from "../t/T";
import "./ComboBox.scss";

class ComboBox extends Component {
  constructor(props) {
    super(props);

    // Refs
    this.comboboxRef = createRef();

    // Global values
    this.valuesLength = 0;

    this.state = {
      isDropDownOpen: false,
      selectedOptions: [],
      dropdownTitle: "all",
      checkAll: true,
      options: [...this.props.values],
      lang: Storage.getLanguage(),
      singleState: this.props.singleChoose || false
    };
  }

  componentDidMount() {
    this.valuesLength = this.state.options.length || 0;
    this.#generateDropdownTitle();

    // First time load checkAll
    // if (this.state.checkAll) {
    //   this.setState({
    //     selectedOptions: [...this.state.options]
    //   });
    // }

    // Detect click outside
    document.addEventListener("mousedown", this.#closeDropDownClickOutside);
    document.addEventListener("resetAllFilters", this.resetSelectedValue);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.language !== this.props.language) {
          this.handleUpdateLanguage(this.props.language);
      }
      if (prevProps.selecteds !== this.props.selecteds) {
        this.resetSelectedValue(()=> {
          let data = this.props.selecteds.map((item) => {
            let t = this.state.options.find(option => option?.id === item || option?.value === item)
            return {...t, name: t?.text, value: t?.value ?? t?.id, checked: true}
          })
          this.setState({selectedOptions: [...data]},()=>{
            this.#generateDropdownTitle()
          })
        })
      }
      if (prevProps.values !== this.props.values) {
          this.setState({
            options: [...this.props.values]
          });
      }
      if (prevState.isDropDownOpen !== this.state.isDropDownOpen){
        if ( this.state.isDropDownOpen === true ) {
          document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
              this.#closeDropDownClickOutside(event);
            }
          })
        } else {
          document.removeEventListener("keydown", ()=>{});
        }
      }
  }

  handleUpdateLanguage(language) {
      this.setState({
          lang: language,
      });
  }

  // * Private methods
  #makeArrayReadyForColumns = (rawArray = [], itemPerColumn = 4) => {
    let finalResult = [];

    if (rawArray.length > 16) {
      itemPerColumn = Math.ceil(rawArray.length / 4);
    }

    while (rawArray.length > 0) {

      finalResult.push(rawArray.splice(0, itemPerColumn));
    }
    
    return finalResult;
  }

  #generateDropdownTitle = (updateState = true, initValue = "all") => {
    let title = _.init(initValue, this.state.lang);

    if (this.state.selectedOptions.length) {
      if (this.state.selectedOptions.length === this.valuesLength) {
        title = _.init(initValue, this.state.lang);
      } else {
        title = this.state.selectedOptions.map(item => _.init(item.name, this.state.lang)).join(",");
      }
    }

    if (updateState)
      this.setState({
        dropdownTitle: title
      });
    else
      return title;
  }

  #closeDropDownClickOutside = (event) => {
    if (this.comboboxRef.current && this.state.isDropDownOpen && !this.comboboxRef.current.contains(event.target)) {
      this.toggleDropDown(false);
    }
  }

  // * Public methods
  resetSelectedValue = (callback) => {
    this.setState({
      selectedOptions: [],
      checkAll: true,
    }, () => {
      this.#generateDropdownTitle();
      try{
        callback()
      } catch (e) {
        console.log("reset callBack is not function!")
      }
    });
  }

  resetButton = () => {
    this.resetSelectedValue(()=>{
      this.props?.onChangeValue(this.props.name, "", this.state.singleState);
    })
  }

  toggleDropDown = (forceValue = null) => {
    this.setState({
      isDropDownOpen: forceValue ?? !this.state.isDropDownOpen
    });
  }

  onChangeOptionsValue = (data = null) => {
    if (!data) {
      throw new Error("Method onChangeOptionsValue`s data parameter is null!!!");
    }
    
    let finalSelectedOptions = [...this.state.selectedOptions];
    let existence = finalSelectedOptions.find(option => option.name === data.name);
    
    if (this.state.singleState) {
      this.singleChoose(existence, finalSelectedOptions, data);
    } else {
      this.multiChoose(existence, finalSelectedOptions, data);
    }
  }

  singleChoose = (existence, options, data) => {
    let finalResult

    if (existence) {
      // Remove from array
      finalResult = [];
    } else {
      // Add to array
      finalResult = [];
      finalResult.push(data);
    }

    this.setState({
      selectedOptions: [...finalResult]
    }, () => {
      this.#generateDropdownTitle();
      // Send selected options key, value
      this.props?.onChangeValue(this.props.name, data.value, this.state.singleState);
    });
  }

  multiChoose = (existence, options, data) => {
    let finalResult = [...options];

    if (existence) {
      // Remove from array
      finalResult = finalResult.filter(item => item.name !== data.name);
    } else {
      // Add to array
      finalResult.push(data);
    }

    this.setState({
      selectedOptions: [...finalResult]
    }, () => {
      this.#generateDropdownTitle();
      // Send selected options key, value
      this.props?.onChangeValue(this.props.name, data.value);
    });
  }

  handleCheckAll = (data) => {
    if (data.checked) {
      this.setState({
        checkAll: true,
        selectedOptions: this.state.options.map(option => ({name: option.text, value: option.id, checked: true}))
      });
    } else {
      this.setState({
        checkAll: false,
        selectedOptions: []
      });
    }
  }

  renderSelectModeDropDown = () => {
    return <div className="dropdown__select-options">
        {
          this.state.options.map(item => <p key={item.id}>{item.rawText} <T token={item.text} /></p>)
        }
      </div>;
  }

  renderCheckBoxModeDropDown = (title, itemsDir = "rtl") => {
    let finalItems = this.#makeArrayReadyForColumns([...this.state.options]);

    return <>
      <div className="dropdown__title">
        <T token={title} />
        <i className={'fa fa-thin fa-arrow-rotate-right customized-buttons redLight'} onClick={this.resetButton}
           title={_.init("reset_this_filters", this.state.language)}/>
      </div>
      <div className="dropdown__options">
        <div className="dropdown-col">
          {/* <CheckBox type="complex" disableMainLabel={true} name="all" value={""} labelText="all" customClass="width-150px" labelDir={itemsDir} handleChangeValue={this.handleCheckAll} checked={this.state.checkAll} /> */}
        </div>
        {
          finalItems.map((col, index) => <div key={index} className="dropdown-col">
            {
              col.map((item, index) => {
                let selectedBefore = this.state.selectedOptions.find(option => option.name === item.text) ;

                return <CheckBox key={index}
                                 type="complex_styled"
                                 name={item.text}
                                 disableMainLabel={true}
                                 value={item.id}
                                 labelText={item.text}
                                 rawText={item.rawText}
                                 rawStyles={item.rawStyles}
                                 customClass="width-160px"
                                 labelDir={itemsDir}
                                 handleChangeValue={this.onChangeOptionsValue}
                                 checked={selectedBefore}
                                 tooltip={item?.description}
                                 disabled={item?.disabled}
                />;
              })
            }
          </div>)
        }
      </div>
    </>;
  }

  render() {
    const {labelText = null, type = "select", itemsDir = "rtl", dropDownTitle = "", dropDownToUp = false, tooltip = ""} = this.props;
    let dropdownType
    this.valuesLength = this.state.options.length;

    switch (type.toLowerCase()) {
      case "select":
        dropdownType = this.renderSelectModeDropDown();
        break;
      case "checkbox":
        dropdownType = this.renderCheckBoxModeDropDown(dropDownTitle, itemsDir);
        break;
      default:
        dropdownType = "Wrong input for type property!!!";
        break;
    }

    return <div className="combobox" ref={this.comboboxRef}>
      {labelText && <Label labelText={labelText} />}
      <div className="combobox__container" onClick={()=> this.toggleDropDown(!this.state.isDropDownOpen)}>
        <div className="main" title={tooltip}>
          <div className="combobox__content" >
            <T token={this.state.dropdownTitle} />
          </div>
          <div className="combobox__arrow" >
            {
              this.state.isDropDownOpen ? <i className="fa fa-angle-up" /> : <i className="fa fa-angle-down" />
            }
          </div>
        </div>
        {
          this.state.isDropDownOpen && 
          <div className={`combobox__dropdown ${type.toLowerCase()}-${dropDownToUp ? "dropdown-up" : "dropdown-down"}`}>
            { type.toLowerCase() !== "select" && <div className="square" />}
            {
              dropdownType
            }
          </div>
        }
      </div>
    </div>;
  }
}

const mapStateToProps = state => {
  const language = state.LangReducer.language;
  return {language};
};

export default connect(mapStateToProps)(ComboBox);
